import React, { useState } from "react";

import { getBaseUnits, getUnitOptions } from "utils/fields";
import { getDecimalPlaces } from "utils/fieldValidation";

import InputWithUnits from "components/Input/InputWithUnits";
import Checkbox from "components/Input/Checkbox";
import InputRow from "components/Input/Row";

import classes from "./styles.module.scss";
import zoneResultsClasses from "../styles.module.scss";

const airFlowDecimals = getDecimalPlaces("ventSupply");
const airFlowUnitOptions = getUnitOptions("airFlow");

const VentilationBreakdown = ({
    results = {},
    displayUnits = "Metric",
}) => {
    const {
        hrv = "No",
        hrvAtre = 0,
        systemServesZone = false,
        designAirHandlingCirculationRate = 0,
        sczVentilationAirFlowRate = 0,
    } = results;

    const airFlowBaseUnits = getBaseUnits("hrvSupply", displayUnits);
    const { trueBase: airFlowTrueBase, displayBase: airFlowDisplayBase } = airFlowBaseUnits;
    const [airFlowUnits, setAirFlowUnits] = useState(airFlowDisplayBase || airFlowTrueBase);
    const airFlowU = airFlowUnits || airFlowDisplayBase || airFlowTrueBase;

    const hasHRV = hrv === "Yes";

    return (
        <div className={zoneResultsClasses.sectionContainer}>
            <div className={zoneResultsClasses.sectionHeader}>
                <h3 className={zoneResultsClasses.sectionTitle}>
                    Cooling & Ventilation Systems
                </h3>
            </div>
            <InputRow gridTemplate="1fr 1fr 1fr" lastRow>
                <Checkbox
                    label="A central air handling system serves the zone"
                    input={{ value: systemServesZone, onChange: () => { } }}
                    disabled
                    large
                />
                {systemServesZone ? (
                    <InputWithUnits
                        label="Design Air Handling Circulation Rate"
                        type="number"
                        input={{
                            value: designAirHandlingCirculationRate,
                            onChange: () => { },
                        }}
                        setValue={designAirHandlingCirculationRate}
                        decimals={airFlowDecimals}
                        units={{
                            base: airFlowBaseUnits,
                            options: airFlowUnitOptions,
                            selected: airFlowU,
                            unitType: "airFlow",
                        }}
                        onUnitChange={(unit) => setAirFlowUnits(unit)}
                        disabled
                    />
                ) : <div></div>}
                <InputWithUnits
                    label="Applied Ventilation Air Flow Rate"
                    type="number"
                    input={{
                        value: sczVentilationAirFlowRate,
                        onChange: () => { },
                    }}
                    setValue={sczVentilationAirFlowRate}
                    decimals={airFlowDecimals}
                    units={{
                        base: airFlowBaseUnits,
                        options: airFlowUnitOptions,
                        selected: airFlowU,
                        unitType: "airFlow",
                    }}
                    onUnitChange={(unit) => setAirFlowUnits(unit)}
                    disabled
                />
            </InputRow>
            <InputRow gridTemplate="1fr 1fr 1fr" lastRow>
                <Checkbox
                    label="The home has an HRV/ERV"
                    input={{ value: hasHRV, onChange: () => { } }}
                    disabled
                    large
                />
                <div></div>
                {hasHRV && (
                    <InputWithUnits
                        label="ATRE %"
                        type="number"
                        input={{
                            value: hrvAtre,
                            onChange: () => { },
                        }}
                        setValue={hrvAtre}
                        decimals={0}
                        units={{
                            base: { trueBase: "%", displayBase: "%" },
                            options: ["%"],
                            selected: "%",
                            unitType: "fraction",
                        }}
                        disabled
                    />
                )}
            </InputRow>
        </div>
    );
};

export default VentilationBreakdown;
